// extracted by mini-css-extract-plugin
module.exports = {"Arrow":"styles_Arrow__F9jC-","ArrowContainer":"styles_ArrowContainer__1Mnm0"};